import React from 'react';
import { Card, Avatar, Typography, Row, Col, Button, Divider, Tag, Space } from 'antd';
import { UserOutlined, MailOutlined, SettingOutlined, SafetyCertificateOutlined } from '@ant-design/icons';
import { useAuthStore } from '../../auth/store/authStore';

const { Title, Text, Paragraph } = Typography;

export const AdminProfilePage: React.FC = () => {
  const { user } = useAuthStore();
  const profile = user?.profile ?? null;

  return (
    <Row justify="center" style={{ marginTop: 32 }}>
      <Col xs={24} sm={20} md={16} lg={12} xl={10}>
        <Card
          bordered={false}
          style={{ borderRadius: 16, boxShadow: '0 2px 12px rgba(0,0,0,0.08)' }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: 24 }}>
            <Avatar
              size={96}
              icon={<UserOutlined />}
              style={{ background: '#1890ff', boxShadow: '0 2px 8px rgba(24,144,255,0.15)' }}
            />
            <div>
              <Title level={3} style={{ marginBottom: 0 }}>
                {profile?.full_name || user?.email || 'Administrador'}
              </Title>
              <Text type="secondary" style={{ fontSize: 16 }}>
                {user?.email}
              </Text>
              <div style={{ marginTop: 8 }}>
                <Tag color="blue" icon={<SafetyCertificateOutlined />}>Administrador</Tag>
              </div>
            </div>
          </div>

          <Divider style={{ margin: '24px 0' }} />

          <Space direction="vertical" size="large" style={{ width: '100%' }}>
            <Paragraph>
              <Text strong>Nome:</Text> {profile?.full_name || 'Não informado'}
            </Paragraph>
            <Paragraph>
              <Text strong>Email:</Text> {user?.email}
            </Paragraph>
            <Paragraph>
              <Text strong>Função:</Text> Administrador
            </Paragraph>
            <Paragraph>
              <Text strong>Status:</Text> <Tag color="green">Ativo</Tag>
            </Paragraph>
          </Space>

          <Divider style={{ margin: '24px 0' }} />

          <Row gutter={16} justify="end">
            <Col>
              <Button type="primary" icon={<SettingOutlined />}>Editar Perfil</Button>
            </Col>
            <Col>
              <Button icon={<MailOutlined />}>Alterar Email</Button>
            </Col>
          </Row>
        </Card>
      </Col>
    </Row>
  );
};
